import React from 'react';
import styled from 'styled-components';

/*

Props:

*/

const StyledDiv = styled.div`
    display: flex;
    flex: 1;
    flex-flow: column nowrap;
    margin-bottom: 25px;
`;


const ServiceCardOuterDiv = ({ style, children, ...rest }) => (
    <StyledDiv style = {style} {...rest} >
        { children }
    </StyledDiv>
)

export default ServiceCardOuterDiv;



// WEBPACK FOOTER //
// ./src/js/components/ServiceCard/ServiceCardOuterDiv.jsx